import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import {appropriateItemSeason, baseUrl, mahatmaRatings } from "../../../comman/config";
import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
   
    const [formData, setFormData] = useState({
        menuitem_eng : '',
        menuitem_guj : '',
        menuitem_category : '',
        menuitem_unit : [],
        menuitem_season : '',
        menuitem_rating: '',
        menuitem_remarks: '',
    });
    const [validationErrors, setValidationErrors] = useState({
        menuitem_eng: false,
        menuitem_guj: false,
        menuitem_category: false,
        menuitem_unit: false,

    });
    const [menuitemCategory, setMenuitemCategory] = useState([]);
    const [methodList, setMethodList] = useState([]);
    // The recipes this item has -- one per maharaj -- and which of them is its default. The flag
    // lives on receipe_master, the same column the Recipe List's Default toggle writes, so the two
    // screens are showing one fact rather than two copies of it.
    const [itemRecipes, setItemRecipes] = useState([]);
    const [defaultRecipeMaharaj, setDefaultRecipeMaharaj] = useState('');
    const [popupOpen , setPopupOpen] = useState(false);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();
    useEffect(() => {
        getMenuitemCategory();
        getMethodList();
    }, []);

    useEffect(() => {
        if(detail){
            setFormData({
                menuitem_eng: detail[0].eng_name || '',
                menuitem_guj: detail[0].item_name || '',
                menuitem_category: detail[0]?.category?.id || '',
                // /item/list resolves method into an array of method_master rows
                menuitem_unit: (detail[0]?.method || []).map((m) => m.id),
                menuitem_season:detail[0]?.season?.toString() || '',
                menuitem_rating:detail[0]?.mahatma_rating?.toString() || '',
                menuitem_remarks:detail[0]?.remarks || '',
            });
        }
        // console.log(detail[0]);
    }, [detail]);

    // Only fetched for an existing item: an item being added has no recipes to choose between yet.
    // The field itself is on both screens -- on Add it stands there saying Auto, which is what a
    // new item is.
    useEffect(() => {
        const itemId = detail?.[0]?.id;
        if (!itemId) return;
        const load = async () => {
            try {
                const response = await axios.get(`${baseUrl}/receipe/item_recipes/${itemId}`);
                const all = (response.data.data ?? []).filter((r) => r.maharaj_id);
                const current = all.find((r) => r.is_default == 1);
                // Only enabled recipes are offered: a disabled recipe is one that is not to be
                // cooked from, so it is not one to stand for the item either. The exception is a
                // recipe that IS the item's default and has since been disabled -- it stays in
                // the list, marked, rather than vanishing. Dropping it would leave the dropdown
                // showing Auto over a stored default and quietly clear the flag on the next save,
                // which is a change nobody asked for.
                const list = all.filter((r) => r.recipe_status == 1 || r.maharaj_id === current?.maharaj_id);
                setItemRecipes(list);
                setDefaultRecipeMaharaj(String(current?.maharaj_id ?? ''));
            } catch (error) {
                console.log(error);
            }
        };
        load();
    }, [detail]);

    const getMenuitemCategory = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=item_category_master&condition=status=1`);
        setMenuitemCategory(response.data.data);
    }
    
    const getMethodList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=method_master&condition=status=1`);
        setMethodList(response.data.data);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        // const gujaratiRegex = /^[\u0A80-\u0AFF\s]+$/;
        const gujaratiRegex = /^[\u0A80-\u0AFF\s()+\-]*$/;
        const newValidationErrors = {
            menuitem_eng: formData.menuitem_eng === '',
            menuitem_guj: formData.menuitem_guj === '' || !gujaratiRegex.test(formData.menuitem_guj),
            menuitem_category : formData.menuitem_category === '',
            menuitem_unit : formData.menuitem_unit === '',
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        console.log(formData);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            console.log(firstInvalidInput);
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `item/edit/${detail[0].id}`;
                }else{
                    url = "item/add";
                }
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                // The default recipe is a column on receipe_master, not on item_master, so it is
                // saved through the endpoint that owns the rule -- the same one the Recipe List
                // toggle calls, which clears the item's other recipes as it sets this one.
                if (detail && itemRecipes.length) {
                    await axios.put(`${baseUrl}/receipe/default`, {
                        menu_item_id: detail[0].id,
                        maharaj_id: defaultRecipeMaharaj === '' ? null : defaultRecipeMaharaj,
                    });
                }
                setPopupOpen(false);
                navigate("/item/list");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const toggleMethod = (methodId) => {
        setFormData((prev) => {
            const selected = prev.menuitem_unit || [];
            return {
                ...prev,
                menuitem_unit: selected.includes(methodId)
                    ? selected.filter((id) => id !== methodId)
                    : [...selected, methodId],
            };
        });
        setValidationErrors((prev) => ({ ...prev, menuitem_unit: false }));
    };

    // Picking a category seeds Default Method from that category's own selection. A default only:
    // every box stays tickable, so an item that differs from its category is one click away.
    const handleCategoryChange = (e) => {
        const categoryId = e.target.value;
        const category = menuitemCategory.find((c) => c.id == categoryId);
        const categoryMethods = String(category?.default_methods || '')
            .split(',').map((v) => parseInt(v, 10)).filter(Boolean);
        setFormData((prev) => ({
            ...prev,
            menuitem_category: categoryId,
            menuitem_unit: categoryMethods.length ? categoryMethods : prev.menuitem_unit,
        }));
        setValidationErrors((prev) => ({ ...prev, menuitem_category: false }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

  return (
 
 <form ref={formRef}>
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 space-y-8 lg:space-y-0 lg:flex lg:gap-x-5 lg:flex-wrap ">
                            <div className="sm:col-span-2">
                                <label htmlFor="menuitem_eng" className="block text-sm font-medium leading-6 text-gray-900">Menuitem Name (Eng)</label>
                                <div className="mt-2">
                                    <input
                                      type="text"
                                      name="menuitem_eng"
                                      id="menuitem_eng"
                                      placeholder='Menuitem Name (Eng)'
                                      value={formData.menuitem_eng}
                                      onChange={handleInputChange}
                                      className={`block w-full rounded-md border ${validationErrors.menuitem_eng ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    />
                                </div>
                                {validationErrors.menuitem_eng && <div className="text-red-500">Please enter a english name.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="menuitem_guj" className="block text-sm font-medium leading-6 text-gray-900">Menuitem Name (Guj)</label>
                                <div className="mt-2">
                                    <input
                                      id="menuitem_guj"
                                      name="menuitem_guj"
                                      type="text"
                                      placeholder='Menuitem Name (Guj)'
                                      value={formData.menuitem_guj}
                                      onChange={handleInputChange}
                                      className={`block w-full rounded-md border ${validationErrors.menuitem_guj ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    />
                                </div>
                                {validationErrors.menuitem_guj && <div className="text-red-500">Please enter a gujarati name.</div>}
                            </div>
                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="menuitem_category" className="block text-sm font-medium leading-6 text-gray-900">Menuitem Category</label>
                                <div className="mt-2">
                                    
                                    <select 
                                      id="menuitem_category"
                                      name="menuitem_category"
                                      type="text"
                                      value={formData.menuitem_category}
                                      onChange={handleCategoryChange}
                                      className={`block w-full rounded-md border ${validationErrors.menuitem_category ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}>
                                        <option value="">Select a Category</option>
                                        {menuitemCategory.map((item) => (
                                            <option value={item.id} key={item.id}>{item.name} ({item.eng_name})</option>
                                        ))};
                                    </select>
                                    
                                </div>
                                {validationErrors.menuitem_category && <div className="text-red-500">Please select a category.</div>}
                            </div>
                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="menuitem_unit" className="block text-sm font-medium leading-6 text-gray-900">Default Method</label>
                                <div className="mt-2">
                                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                                        {methodList.map((method) => (
                                            <label key={method.id} className="flex items-center gap-x-2 text-sm text-gray-900">
                                                <input
                                                  type="checkbox"
                                                  name="menuitem_unit"
                                                  value={method.id}
                                                  checked={(formData.menuitem_unit || []).includes(method.id)}
                                                  onChange={() => toggleMethod(method.id)}
                                                />
                                                <span>{method.name}</span>
                                            </label>
                                        ))}
                                    </div>
                                   
                                </div>
                                {validationErrors.menuitem_unit && <div className="text-red-500">Please select at least one method.</div>}
                            </div>
                        </div>
                        {/* An item can have a recipe per maharaj; this names the one that stands
                            for the item. It is the same flag the Recipe List's Default column
                            toggles, so setting it here also unsets whichever recipe held it.

                            Naming a recipe here also fills Maharaj Name on Menu Creation, Menu
                            Edit and Meal Master when this item is put on a menu. "Auto" -- no
                            recipe named -- leaves those screens choosing the maharaj the way they
                            always have, from the item's category.

                            On Add it is disabled and reads Auto: a new item has no recipes to be
                            default of, and saying so is clearer than the field not being there
                            and turning up later. */}
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="default_recipe" className="block text-sm font-medium leading-6 text-gray-900">Default Recipe</label>
                                <div className="mt-2">
                                    <select
                                      id="default_recipe"
                                      name="default_recipe"
                                      value={defaultRecipeMaharaj}
                                      onChange={(e) => setDefaultRecipeMaharaj(e.target.value)}
                                      disabled={itemRecipes.length === 0}
                                      className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 disabled:bg-gray-100">
                                        <option value="">Auto</option>
                                        {itemRecipes.map((recipe) => (
                                            <option value={recipe.maharaj_id} key={recipe.maharaj_id}>
                                                {recipe.maharaj_name}{recipe.recipe_status == 1 ? '' : ' (Disabled)'}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {itemRecipes.length === 0 && (
                                    <div className="text-sm text-gray-500 mt-1">
                                        {detail ? 'This item has no enabled recipes yet.' : 'Add the item first, then its recipes.'}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="menuitem_season" className="block text-sm font-medium leading-6 text-gray-900 ">આઇટમ માટે યોગ્ય સીઝન (Appropriate season for the item)</label>
                                <div className="mt-2">
                                <select 
                                      id="menuitem_season"
                                      name="menuitem_season"
                                      type="text"
                                      value={formData.menuitem_season}
                                      onChange={handleInputChange}
                                      className={`block w-full rounded-md border ${validationErrors?.menuitem_season ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}>
                                        <option value="">Select a season</option>
                                        {appropriateItemSeason.map((item) => (
                                            <option value={item.value} key={item.value}>{item.label}</option>
                                        ))};
                                    </select>
                                   
                                </div>
                            </div>
                    </div>
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="menuitem_rating" className="block text-sm font-medium leading-6 text-gray-900 ">Item Rating by Mahatmas</label>
                                <div className="mt-2">
                                {mahatmaRatings.map((item)=>(
                                    <div key={item.value} className="flex items-center">
                                    <input 
                                        id={`menuitem_season_${item.value}`} // Unique id for each radio button
                                        name="menuitem_rating" 
                                        type="radio"
                                        value={item.value}
                                        checked={formData.menuitem_rating === item.value.toString()}
                                        onChange={handleInputChange}
                                        className={`h-4 w-4 border ${validationErrors?.menuitem_rating ? 'border-red-500' : 'border-gray-300'} text-indigo-600 focus:ring-indigo-600`}
                                    />
                                    <label htmlFor={`menuitem_season_${item.value}`} className="ml-3 block text-sm font-medium text-gray-900">
                                        {item.label}
                                    </label>
                                </div>
                                ))}
                                </div>
                            </div>
                    </div>
                    {/* The same six-column grid every other row on this form uses. It was a flex
                        row, and the col-span on the field below meant nothing inside it, so the
                        box took its width from its content and came out narrower than the
                        single-line inputs above it. */}
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2 lg:col-span-4">
                                <label htmlFor="menuitem_remarks" className="block text-sm font-medium leading-6 text-gray-900">Remarks</label>
                                <div className="mt-2">
                                    {/* A textarea, not a single-line input: a remark on an item is a
                                        note about how it is made, and a one-line box hid all but
                                        the start of it. Four columns of the six rather than the two
                                        a name or a rating takes -- a remark is a sentence, and it is
                                        read back on this screen as often as it is written.
                                        Same name and handler, so nothing about how it is stored
                                        changes. */}
                                    <textarea
                                      rows={3}
                                      name="menuitem_remarks"
                                      id="menuitem_remarks"
                                      placeholder='Remarks'
                                      value={formData.menuitem_remarks}
                                      onChange={handleInputChange}
                                      className={`block w-full rounded-md border ${validationErrors?.menuitem_remarks ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    />
                                </div>
                            </div>
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/item/list">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }